/* eslint-disable react/jsx-pascal-case */
/* Original name @uswitch/trustyle.hero-card */

import * as React from 'react'
import { Themed } from 'theme-ui'
import { ButtonLink } from '../../elements/button-link'

const styles = element => `compounds.heroCard.variants${element ? `.${element}` : ''}`

const HeroCard = ({ title, ctaText, ctaLink, children, bgImage, type = 'default' }) => {
  return (
    <div
      sx={{
        display: 'flex',
        variant: styles(type === 'seasonal' ? 'seasonal' : ''),
      }}
    >
      <div sx={{ variant: styles('flexContainer') }}>
        <Themed.h1 as='h2'>{title}</Themed.h1>
        <If condition={type === 'seasonal'}>
          <div
            sx={{
              variant: styles('links.seasonal'),
            }}
          >
            {children}
          </div>
        </If>
        <If condition={ctaText}>
          <ButtonLink
            variant='primary'
            href={ctaLink}
            size={children && type === 'seasonal' ? 'fullWidth' : 'small'}
            sx={{
              variant: styles('buttonLink'),
              display: ['none', 'initial'],
            }}
          >
            {ctaText}
          </ButtonLink>
        </If>
      </div>
      <If condition={type === 'default'}>
        <div
          sx={{
            variant: styles('links'),
          }}
        >
          {children}
        </div>
      </If>
      <If condition={ctaText}>
        <ButtonLink
          variant='primary'
          href={ctaLink}
          size={children && type === 'seasonal' ? 'fullWidth' : 'small'}
          sx={{
            variant: styles('buttonLink'),
            display: ['initial', 'none'],
          }}
        >
          {ctaText}
        </ButtonLink>
      </If>
      <If condition={bgImage}>
        <div
          sx={{
            display: ['none', 'none', 'block'],
            background: `url(${bgImage}) no-repeat right center / contain`,
            width: '404px',
            height: '416px',
          }}
        ></div>
      </If>
    </div>
  )
}

export default HeroCard
